import Console from '@/libs/console';

/**
 * Stores data in browser's localStorage.
 * @module DeviceStorage
 * @author Lanza
 */
export default {
  storage: null,
  storageKey: 'vizzto-persistent-data',

  hasLocalStorage() {
    if (localStorage) {
      const testKey = '__vizzto_storage_test__';
      try {
        localStorage.setItem(testKey, 'test');
        localStorage.removeItem(testKey);
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  },

  getStorage() {
    if (!this.storage) {
      if (this.hasLocalStorage()) {
        this.storage = localStorage;
      } else {
        const nothing = () => null;
        this.storage = {
          getItem: nothing,
          setItem: nothing,
          removeItem: nothing
        };
      }
    }
    return this.storage;
  },

  /**
   * Gets data stored in localStorage.
   * @returns {Object}
   */
  data() {
    try {
      const storageContent = this.getStorage().getItem(this.storageKey) || '{}';
      return JSON.parse(storageContent);
    } catch (err) {
      Console.log(err);
      return {};
    }
  },

  /**
   * Gets data in localStorage of given key.
   * @param {String} key
   * @returns {*|null}
   */
  get(key) {
    const data = this.data();
    return data[key] || null;
  },

  /**
   * Sets data for given key in localStorage.
   * @param {String} key
   * @param {*} value
   */
  set(key, value) {
    const data = this.data();
    data[key] = value;
    try {
      this.getStorage().setItem(this.storageKey, JSON.stringify(data));
    } catch (err) {
      Console.log(err);
    }
  },

  /**
   * Remove specific data holder in localStorage.
   */
  remove(key) {
    const data = this.data();
    if (data.hasOwnProperty(key)) {
      delete data[key];
      this.getStorage().setItem(this.storageKey, JSON.stringify(data));
    }
  }
};
